import axios from "@/lib/axios"

export const fetchStatistics = async () => {
    const { data } = await axios(`/api/thelma/citizen/home`)
    return data
}